module.exports = __webpack_public_path__ + "img/history_timeline_8.944055ed.png";